import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin, Clock } from 'lucide-react';
const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const scrollToSection = (id: string) => {
    if (!isHomePage) {
      // If not on home page, navigate to home with hash
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // If no specific ID, scroll to top for "Home"
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-gray-800 text-white" data-id="element-117">
      <div className="container mx-auto px-4 py-12" data-id="element-118">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-119">
          {/* Company Info */}
          <div data-id="element-120">
            <h3 className="text-xl font-bold mb-4" data-id="element-121">I75 Audio & Video, LLC</h3>
            <p className="text-gray-300 mb-6" data-id="element-122">
              Southwest Florida's premier provider of audio, video, and smart
              technology solutions for homes and businesses.
            </p>
            <div className="flex space-x-4" data-id="element-123">
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="Facebook" data-id="element-124">
                <Facebook className="w-5 h-5" data-id="element-125" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="Instagram" data-id="element-126">
                <Instagram className="w-5 h-5" data-id="element-127" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="Twitter" data-id="element-128">
                <Twitter className="w-5 h-5" data-id="element-129" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-130">
                <Linkedin className="w-5 h-5" data-id="element-131" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-132">
            <h3 className="text-xl font-bold mb-4" data-id="element-133">Quick Links</h3>
            <ul className="space-y-2" data-id="element-134">
              <li data-id="element-135">
                {isHomePage ? <button onClick={() => scrollToSection('top')} className="text-gray-300 hover:text-white transition-colors" data-id="element-136">
                    Home
                  </button> : <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-137">
                    Home
                  </Link>}
              </li>
              <li data-id="element-138">
                {isHomePage ? <button onClick={() => scrollToSection('about-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-139">
                    About Us
                  </button> : <Link to="/#about-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-140">
                    About Us
                  </Link>}
              </li>
              <li data-id="element-141">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-142">
                    Services
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-143">
                    Services
                  </Link>}
              </li>
              <li data-id="element-144">
                {isHomePage ? <button onClick={() => scrollToSection('gallery-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-145">
                    Projects
                  </button> : <Link to="/#gallery-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-146">
                    Projects
                  </Link>}
              </li>
              <li data-id="element-147">
                {isHomePage ? <button onClick={() => scrollToSection('testimonials-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-148">
                    Testimonials
                  </button> : <Link to="/#testimonials-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-149">
                    Testimonials
                  </Link>}
              </li>
              <li data-id="element-150">
                {isHomePage ? <button onClick={() => scrollToSection('contact-form')} className="text-gray-300 hover:text-white transition-colors" data-id="element-151">
                    Contact
                  </button> : <Link to="/#contact-form" className="text-gray-300 hover:text-white transition-colors" data-id="element-152">
                    Contact
                  </Link>}
              </li>
              <li data-id="element-153">
                <button onClick={() => alert('Privacy Policy information would appear here.')} className="text-gray-300 hover:text-white transition-colors" data-id="element-154">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-155">
            <h3 className="text-xl font-bold mb-4" data-id="element-156">Our Services</h3>
            <ul className="space-y-2" data-id="element-157">
              <li data-id="element-158">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-159">
                    Home Theater Installation
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-160">
                    Home Theater Installation
                  </Link>}
              </li>
              <li data-id="element-161">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-162">
                    Commercial Audio Systems
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-163">
                    Commercial Audio Systems
                  </Link>}
              </li>
              <li data-id="element-164">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-165">
                    Camera & Monitoring
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-166">
                    Camera & Monitoring
                  </Link>}
              </li>
              <li data-id="element-167">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-168">
                    WiFi & Networking
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-169">
                    WiFi & Networking
                  </Link>}
              </li>
              <li data-id="element-170">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-171">
                    Smart Home Programming
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-172">
                    Smart Home Programming
                  </Link>}
              </li>
              <li data-id="element-173">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-174">
                    Video Distribution
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-175">
                    Video Distribution
                  </Link>}
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-176">
            <h3 className="text-xl font-bold mb-4" data-id="element-177">Contact Us</h3>
            <ul className="space-y-4" data-id="element-178">
              <li className="flex" data-id="element-179">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-180" />
                <span data-id="element-181">
                  <a href="tel:2392038333" className="hover:text-blue-300 transition-colors" data-id="element-182">
                    (239) 203-8333
                  </a>
                </span>
              </li>
              <li className="flex" data-id="element-183">
                <Mail className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-184" />
                <span data-id="element-185">
                  <a href="mailto:info@i75av.com" className="hover:text-blue-300 transition-colors" data-id="element-186">
                    info@i75av.com
                  </a>
                </span>
              </li>
              <li className="flex" data-id="element-187">
                <MapPin className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-188" />
                <span data-id="element-189">Cape Coral, Florida</span>
              </li>
              <li className="flex" data-id="element-190">
                <Clock className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-191" />
                <span data-id="element-192">
                  Mon-Fri: 8am - 6pm
                  <br data-id="element-193" />
                  Sat: 10am - 4pm
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 text-center" data-id="element-194">
          <p className="text-gray-400" data-id="element-195">
            © {new Date().getFullYear()} I75 Audio & Video, LLC. All rights
            reserved. Licensed and Insured in the State of Florida.
          </p>
          <p className="text-gray-400 mt-2" data-id="element-196">
            FL License #ES12002457 | NY License #12000310349
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;